import React, { forwardRef } from 'react';

const Switch = forwardRef(({
  checked = false,
  onChange,
  name,
  id,
  disabled = false,
  label,
  size = 'default',
  className = '',
  ...props
}, ref) => {
  const sizeClasses = {
    sm: {
      track: 'w-8 h-4',
      thumb: 'w-3 h-3',
      translate: 'translate-x-4',
    },
    default: {
      track: 'w-11 h-6',
      thumb: 'w-5 h-5',
      translate: 'translate-x-5',
    },
    lg: {
      track: 'w-14 h-7',
      thumb: 'w-6 h-6',
      translate: 'translate-x-7',
    },
  };

  const sizes = sizeClasses[size] || sizeClasses.default;

  return (
    <label className={`flex items-center gap-3 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}>
      <div className="relative">
        <input
          ref={ref}
          type="checkbox"
          name={name}
          id={id || name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="sr-only peer"
          {...props}
        />
        <div className={`
          ${sizes.track} rounded-full transition-colors duration-200
          ${checked ? 'bg-brand-500' : 'bg-stroke dark:bg-strokedark'}
          peer-focus:ring-2 peer-focus:ring-brand-500/20
          peer-disabled:opacity-50
        `}>
          <div className={`
            ${sizes.thumb} rounded-full bg-white shadow-md
            absolute top-0.5 left-0.5 transition-transform duration-200
            ${checked ? sizes.translate : 'translate-x-0'}
          `} />
        </div>
      </div>
      {label && (
        <span className="text-sm text-black dark:text-white">{label}</span>
      )}
    </label>
  );
});

Switch.displayName = 'Switch';

export default Switch;
